

<!-- cart header -->
<div class="row d-flex flex-row cart-header row-bottom-bordered">

  <div class="col-xl-5 col-lg-6 col-md-6 col-sm-5 col-5 th-productdetails">
    {{ 'orders.product' | translate }}
  </div>

  <!--
    SK 22-01-2019 - this not a separate column anymore
  <div class="d-none d-xl-block col-xl-2 col-lg-2 d-md-none d-sm-none" *ngIf="showDeliveryColumn">
    {{ 'order.delivery' | translate }}
  </div>
  -->

  <!--
  <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 cart-no-left-padding text-center trashcan" *ngIf="editable">
  </div>
  -->

  <!-- relative mode -->
  <div class="col-xl-4 col-lg-3 col-md-4 col-sm-5 col-7 text-left th-quantity" *ngIf="quantityPickerRelative">
    <div class="row">
      <div class="col-xl-7 col-lg-12">{{ 'order.quantity' | translate }}</div>
      <div class="d-none d-xl-block col-xl-3 text-center">{{ 'order.unit' | translate }}</div>
      <div class="d-none d-xl-block col-xl-2 text-right">{{ 'order.pieces-abbrev' | translate }}</div>
    </div>
  </div>
  <!-- absolute mode -->
  <div class="col-xl-4 col-lg-3 col-md-4 col-sm-5 col-7 text-left" *ngIf="!quantityPickerRelative">
      <div>{{ 'order.quantity' | translate }}</div>
  </div>

  <div class="d-xl-block col-xl-1 d-lg-none d-md-none d-sm-none d-none text-right">
      {{ 'order.price' | translate }}
  </div>
  <div class="d-none col-xl-2 col-lg-3 col-md-2 col-sm-2 d-sm-block cart-no-left-padding text-right">
    {{ 'order.total' | translate }}
  </div>
</div>

<!-- lines -->
<app-cart-table-line *ngFor="let line of lines"
                      class="row row-bottom-bordered d-flex flex-row"
                      [line]="line"
                      [editable]="editable"
                      [currency]="currency"
                      [showDeliveryColumn]="showDeliveryColumn"
                      [quantityPicker]="quantityPicker"
                      [inBackorder]="isLineInBackorder(line)"
                      [showDiscount]="showLineDiscount"
                      [showFacets]="showFacets"
                      (onDetails)="openDetails($event)"
                      (onLineChange)="changeLine($event)"
                      (onLineDelete)="deleteLine($event)">
</app-cart-table-line>

<!-- cart footer -->
<div class="row d-flex flex-row cart-footer">

  <!-- SK removed orderdiscount here -->
  <!--

    <div class="col-md-8">
  </div>
  <div class="col-md-2">

    <ng-container *ngIf="orderDiscount">
      {{ orderDiscount | price:currency }}
    </ng-container>
  </div>
  -->

  <!-- UOM values -->
  <div class="col-md-6 text-left" *ngIf="showUomValues">
    <div *ngFor="let uomValueKey of showUomInfoForUoms" class="uom-values">
      {{ 'entity.label.product.quantitiesinuom.' + uomValueKey | lowercase | translate }}: {{ getUomValueForUom(uomValueKey) | numberFormat:null:'1.2-2' }}
    </div>
  </div>

  <!-- Show total when no extra costs are available -->
  <ng-container *ngIf="!showExtraCosts">
    <div class="text-right" [ngClass]="{'col-md-10': !showUomValues, 'col-md-4': showUomValues}">{{ 'order.total' | translate }}</div>
    <div class="col-md-2 text-right total-price">{{ orderSubTotal | price:currency }}</div>
  </ng-container>

  <!-- Show subtotal, extra costs and total when extra costs are available -->
  <ng-container *ngIf="showExtraCosts">
    <div class="text-right" [ngClass]="{'col-md-10': !showUomValues, 'col-md-4': showUomValues}">{{ 'order.subtotal' | translate }}</div>
    <div class="col-md-2 text-right">{{ orderSubTotal | price:currency }}</div>

    <!-- Extra costs -->
    <ng-container *ngFor="let extraCost of extraCosts">
      <div class="col-md-10 text-right">{{ 'entity.label.extracost.' + extraCost.key | lowercase | translate }}</div>
      <div class="col-md-2 text-right">{{ extraCost.value | price:currency }}</div>
    </ng-container>

    <div class="col-md-10 text-right">{{ 'order.total' | translate }}</div>
    <div class="col-md-2 text-right total-price">{{ orderTotal | price:currency }}</div>
  </ng-container>
</div>
